@if (interventionStore.tasksLoading() && groups().length === 0) {
  <mat-card class="rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
    <div class="flex items-center gap-3 text-sm text-slate-600">
      <mat-spinner diameter="20" />
      Loading tasks...
    </div>
  </mat-card>
} @else {
  <div class="grid gap-4">
    @for (group of groups(); track group.stage) {
      <mat-card
        class="rounded-3xl border p-4 shadow-lg shadow-slate-200/60"
        [class.border-slate-200]="group.state !== 'current'"
        [class.border-blue-400]="group.state === 'current'"
        [class.bg-blue-50]="group.state === 'current'"
        [class.opacity-70]="group.state === 'upcoming'">
        <div class="mb-2 flex items-center justify-between gap-3">
          <h3 class="flex items-center gap-2 text-lg font-semibold text-slate-900">
            {{ label(group.stage) }}
            @if (group.state === 'current') {
              <span class="rounded-full bg-blue-600 px-2 py-0.5 text-xs font-medium text-white">Current</span>
            }
          </h3>
          @if (group.total > 0) {
            <span class="text-sm text-slate-500">{{ group.done }} of {{ group.total }} done</span>
          }
        </div>

        @if (group.tasks.length === 0) {
          <p class="text-sm text-slate-500">No tasks are defined for this stage.</p>
        } @else {
          <div class="grid gap-1">
            @for (task of group.tasks; track task.id) {
              <div class="flex items-center justify-between gap-3 border-b border-slate-100 py-2 text-sm last:border-b-0">
                <div class="flex items-center gap-2">
                  @switch (task.status) {
                    @case ('Completed') {
                      <mat-icon class="!text-base text-green-600">check_circle</mat-icon>
                    }
                    @case ('Cancelled') {
                      <mat-icon class="!text-base text-slate-300">cancel</mat-icon>
                    }
                    @default {
                      <mat-icon class="!text-base text-slate-400">radio_button_unchecked</mat-icon>
                    }
                  }
                  <span
                    [class.text-slate-700]="task.status === 'Pending'"
                    [class.text-slate-400]="task.status !== 'Pending'"
                    [class.line-through]="task.status !== 'Pending'">
                    {{ task.name }}
                  </span>
                  @if (task.status === 'Cancelled') {
                    <span class="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-500">Cancelled</span>
                  } @else if (task.isRequiredForTransition) {
                    <span class="rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700">Required</span>
                  }
                </div>

                @if (task.status === 'Pending' && group.state === 'current' && canComplete()) {
                  <button
                    mat-stroked-button
                    type="button"
                    [disabled]="interventionStore.completingTask()"
                    (click)="complete(task)">
                    Mark complete
                  </button>
                }
              </div>
            }
          </div>
        }
      </mat-card>
    }
  </div>
}
